<div class="container" style="display: flex; flex-direction: column; padding:24px; height:100%">

  <div class="row" style="background-color: var(--elog-brand);">
    <h1 class="display-5" style="color: var(--elog-brand-on); margin-bottom: 0px; padding: 12px;">Sets on this Delivery</h1>
  </div>

  <mat-divider></mat-divider>

  <div class="row" *ngIf="dialogData.fishery !== 'Trawl'">
    <mat-selection-list [(ngModel)]="selected" [compareWith]="compareFn">
      <div *ngFor="let set of options">
        <mat-list-option [value]="set">
          <div *ngIf="dialogData.fishery == 'HMS'" style="display: flex; flex-wrap: wrap;">
            @if (set.startDate) {<span style="font-size: larger;"> {{ set.startDate | date:'yyyy-MM-dd' }} </span>}
            @else {<span style="font-style: italic;">No Date</span>}
            <span style="font-size: smaller;font-weight: bold;font-style: italic; padding-left: 15px;" *ngIf="valid[set.fishingEventID]">Complete</span>
            <span style="font-size: smaller;font-weight: bold;font-style: italic; padding-left: 15px;" *ngIf="!valid[set.fishingEventID]">Incomplete - Check for errors</span>
          </div>
          <div *ngIf="dialogData.fishery == 'Groundfish'" >
            <span style="font-size: larger;">{{set}}</span>
            <span style="font-size: smaller;font-weight: bold;font-style: italic; padding-left: 15px;" *ngIf="valid[set.fishingEventID]">Complete</span>
            <span style="font-size: smaller;font-weight: bold;font-style: italic; padding-left: 15px;" *ngIf="!valid[set.fishingEventID]">Incomplete - Check for errors</span>
          </div>        
        </mat-list-option>
        <mat-divider></mat-divider>
        <br>
      </div>
    </mat-selection-list>
  </div>

    <!-- Trawl selection list -->
    <div class="row" *ngIf="dialogData.fishery === 'Trawl'">
      <mat-selection-list [(ngModel)]="trawlSelected" [compareWith]="compareFn">
        <div *ngFor="let set of trawlOptions">
          <mat-list-option [value]="set">
            <span style="font-size: larger;">{{ set }}</span>
            <span style="font-size: smaller; font-weight: bold; font-style: italic; padding-left: 15px;"
                  *ngIf="valid[set.fishingEventID]">Complete</span>
            <span style="font-size: smaller; font-weight: bold; font-style: italic; padding-left: 15px;"
                  *ngIf="!valid[set.fishingEventID]">Incomplete - Check for errors</span>
          </mat-list-option>
          <mat-divider></mat-divider>
          <br>
        </div>
      </mat-selection-list>
    </div>

  <!-- Cancel or put set into delivery -->
  <div class="row justify-content-between" style="margin-top: auto;">
    <div class="col-4 d-flex justify-content-end">
      <div class="row">
        <button mat-fab
                class="text-blue-button"
                type="button"
                (click)="dialogRef.close()">
          Cancel
        </button>
      </div>
    </div>
    <div class="col-4">
      <div class="row">
        <button mat-fab
                class="text-button"
                type="button"
                (click)="dialogRef.close(dialogData.fishery === 'Trawl' ? this.trawlSelected : this.selected)">
          OK
        </button>
      </div>
    </div>
  </div>


</div>
